import axios from "axios";

const API_BASE_URL = "https://api.jamboricg.com";
const LOCAL_BASE_URL = "http://127.0.0.1:8000";
export const IMG_BASE_URL = API_BASE_URL


export const AdminLogin = async (newsData) => {
  const response = await axios.post(`${API_BASE_URL}/users/api/v1/login/`, newsData);
  return response.data;
};

// Fetch single news item
export const fetchNewsById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/news/api/v1/news/${id}/`);
  return response.data;
};

// Update news
export const updateNews = async ({ id, data }) => {
  const response = await axios.put(`${API_BASE_URL}/news/api/v1/news/${id}/`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    }
  });
  return response.data;
};

// Delete news
export const deleteNews = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/news/api/v1/news/${id}/`);
  return response.data;
};

// Function to fetch news from API
export const fetchNews = async () => {
  const response = await axios.get(`${API_BASE_URL}/news/api/v1/news/list/`);
  return response.data;
};

export const createNews = async (newsData) => {
  const response = await axios.post(`${API_BASE_URL}/news/api/v1/news/add/`, newsData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct data encoding
    }
  });
  return response.data;
};

// Fetch single news item
export const fetchPortifolioById = async (id) => {
  const response = await axios.get(`${API_BASE_URL}/portifolio/api/v1/${id}/`);
  return response.data;
};

// Update news
export const updatePortifolio = async ({ id, data }) => {
  const response = await axios.put(`${API_BASE_URL}/portifolio/api/v1/${id}/`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct data encoding
    }
  });
  return response.data;
};

// Delete news
export const deletePortifolio = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/portifolio/api/v1/${id}/`);
  return response.data;
};

// Function to fetch news from API
export const fetchPortifolio = async () => {
  const response = await axios.get(`${API_BASE_URL}/portifolio/api/v1/list/`);
  return response.data;
};

export const createPortifolio = async (newsData) => {
  const response = await axios.post(`${API_BASE_URL}/portifolio/api/v1/add/`, newsData);
  return response.data;
};


export const fetchJobs = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/formore/api/v1/jobs/`);
  return data;
};

export const deleteJob = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/formore/api/v1/jobs/${id}/`);
  return response.data;
};

export const createJob = async (newsData) => {
  const response = await axios.post(`${API_BASE_URL}/formore/api/v1/jobs/`, newsData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct data encoding
    }
  });
  return response.data;
};

export const updateJob = async ({ id, data }) => {
  const response = await axios.put(`${API_BASE_URL}/formore/api/v1/jobs/${id}/`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct data encoding
    }
  });
  return response.data;
};

export const fetchBanners = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/banners/api/v1/banners/`);
  return data;
};

export const deleteBanner = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/banners/api/v1/banners/${id}/`);
  return response.data;
};
export const createBanner = async (newsData) => {
  const response = await axios.post(`${API_BASE_URL}/banners/api/v1/banners/`, newsData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct data encoding
    }
  });
  return response.data;
};

export const fetchFAQs = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/guide/api/v1/faqs/`);
  return data;
};

export const fetchUserQuestions = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/guide/api/v1/user-questions/`);
  return data;
};


export const createFaq = async (newsData) => {
  const response = await axios.post(`${API_BASE_URL}/guide/api/v1/faqs/`, newsData,
  );
  return response.data;
};

export const deleteFaq = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/guide/api/v1/faqs/${id}/`);
  return response.data;
};
export const updateFaq = async ({ id, data }) => {
  const response = await axios.put(`${API_BASE_URL}/guide/api/v1/faqs/${id}/`, data,);
  return response.data;
};

export const answerQuestion = async ({ id, answer }) => {
  const { data } = await axios.put(`${API_BASE_URL}/guide/api/v1/answer-question/${id}/`, { answer });
  return data;
};

export const fetchUvunajiAssets = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/uvunaji/api/v1/assets/`);
  return data;
};

export const createUvunajiAsset = async (newsData) => {
  const response = await axios.post(`${API_BASE_URL}/uvunaji/api/v1/assets/add/`, newsData, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct data encoding
    }
  })
  return response.data;
};

// Update news
export const updateUvunajiAsset = async ({ id, data }) => {
  const response = await axios.put(`${API_BASE_URL}/uvunaji/api/v1/assets/${id}/update/`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct data encoding
    }
  });
  return response.data;
};

export const deleteUvunajiAsset = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/uvunaji/api/v1/assets/${id}/delete/`);
  return response.data;
};

export const fetchUvuajiInvestments = async () => {
  const response = await axios.get(`${API_BASE_URL}/uvunaji/api/v1/admin/investments/`,
    //   {
    //   headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    // }
  );
  return response.data;
};

export const deleteAdminInvestment = async (id, refund = false, restore = true) => {
  const token = localStorage.getItem('token')
  const response = await axios.delete(
    `${API_BASE_URL}/uvunaji/api/v1/admin/investments/${id}/delete/?refund=${refund}&restore_quantity=${restore}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  )
  return response.data
}
export const fetchUrithiAssets = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/urithi/api/v1/assets/`);
  return data;
};

// export const createUrithiAsset = async (newsData) => {
//   const response = await axios.post(`${API_BASE_URL}/urithi/api/v1/assets/add/`, newsData, {
//     headers: {
//       "Content-Type": "multipart/form-data", 
//     }
//   })
//   return response.data;
// };
export const createUrithiAsset = async (payload) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
 
  // Append all scalar fields
  Object.keys(payload).forEach((key) => {
    if (key === 'images') return; // handled below
    const value = payload[key];
    if (value !== null && value !== undefined && value !== '') {
      formData.append(key, value);
    }
  });
 
  // Append each image as a separate `images` entry — backend reads
  // request.FILES.getlist('images')
  if (Array.isArray(payload.images)) {
    payload.images.forEach((file) => formData.append('images', file));
  }
 
  const response = await axios.post(
    `${API_BASE_URL}/urithi/api/v1/assets/add/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: token ? `Token ${token}` : undefined,
      },
    }
  );
  return response.data;
};

// Update news
export const updateUrithiAsset = async ({ id, data }) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
 
  Object.keys(data).forEach((key) => {
    if (key === 'images') return;
    const value = data[key];
    if (value !== null && value !== undefined && value !== '') {
      formData.append(key, value);
    }
  });
 
  // Only send `images` if new files were selected. If omitted, the backend
  // leaves the existing gallery untouched. If sent, the gallery is replaced.
  if (Array.isArray(data.images) && data.images.length > 0) {
    data.images.forEach((file) => formData.append('images', file));
  }
 
  const response = await axios.put(
    `${API_BASE_URL}/urithi/api/v1/assets/update/${id}/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: token ? `Token ${token}` : undefined,
      },
    }
  );
  return response.data;
};
// export const updateUrithiAsset = async ({ id, data }) => {
//   console.log('pressed!')
//   const response = await axios.put(`${API_BASE_URL}/urithi/api/v1/assets/update/${id}/`, data, {
//     headers: {
//       "Content-Type": "multipart/form-data", 
//     }
//   });
//   return response.data;
// };

export const deleteUthiriAsset = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/urithi/api/v1/assets/delete/${id}/`);
  return response.data;
};

export const fetchUrithiDummyAssets = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/urithi/api/v1/assets/dummy-products/`);
  return data;
};

export const createUrithiDummyAsset = async (newsData) => {
  const response = await axios.post(`${API_BASE_URL}/urithi/api/v1/assets/dummy-products/`, newsData, {
    headers: {
      "Content-Type": "multipart/form-data", 
    }
  })
  return response.data;
};

// Update news
export const updateUrithiDummyAsset = async ({ id, data }) => {
  const response = await axios.put(`${API_BASE_URL}/urithi/api/v1/assets/dummy-products/${id}/`, data, {
    headers: {
      "Content-Type": "multipart/form-data", // Ensures correct data encoding
    }
  });
  return response.data;
};

export const deleteUthiriDummyAsset = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/urithi/api/v1/assets/dummy-products/${id}/`);
  return response.data;
};

export const fetchUrithiPurchases = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/urithi/api/v1/assets/all-purchases/`);
  return data;
};

export const deleteUrithiPurchase = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/urithi/api/v1/assets/purchase/delete/${id}/`);
  return response.data;
};

// Fetch all installment payments for the authenticated user
export const fetchAllInstallments = async () => {
  const response = await axios.get(`${API_BASE_URL}/urithi/api/v1/installments/`,
    //   {
    //   headers: {
    //     Authorization: `Token ${localStorage.getItem("token")}`, // Adjust as needed
    //   },
    // }
  );
  return response.data;
};

export const fetchUrithiDummyOrders = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/urithi/api/v1/admin/orders/`,
    //    {
    //   headers: { Authorization: 'Token YOUR_ADMIN_AUTH_TOKEN' }
    // }
  );
  return data;
};

export const updateUrithiDummyOrderStatus = async ({ id, status }) => {
  await axios.post(`${API_BASE_URL}/urithi/api/v1/admin/order/${id}/update-status/`, { order_status: status },
    //    {
    //   headers: { Authorization: 'Token YOUR_ADMIN_AUTH_TOKEN' }
    // }
  );
};

export const fetchUrithiMonthlyServices = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/urithi/api/v1/service-plans/`);
  return data;
};

export const createUrithiMonthlyService = async (newsData) => {
  const response = await axios.post(`${API_BASE_URL}/urithi/api/v1/service-plans/`, newsData,
    // {
    // headers: {
    //   "Content-Type": "multipart/form-data", // Ensures correct data encoding
    // }}
  )
  return response.data;
};

// Update news
export const updateUrithiMonthlyServices = async ({ id, data }) => {
  const response = await axios.put(`${API_BASE_URL}/urithi/api/v1/service-plans/${id}/`, data,

  );
  return response.data;
};

export const deleteUthiriMonthlyServices = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}/urithi/api/v1/service-plans/${id}/`);
  return response.data;
};

export const fetchUrithiPayments = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/urithi/api/v1/payments/`);
  return data;
};

export const fetchUrithiSubscriptions = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/urithi/api/v1/subscriptions/`);
  return data;
};

export const fetchJibebePackages = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/jibebe/api/v1/jibebe-package`);
  return data;
};

export const createJibebeFighterPackage = async (newsData) => {
  const response = await axios.post(`${API_BASE_URL}/jibebe/api/v1/jibebe-package`, newsData,
    // {
    // headers: {
    //   "Content-Type": "multipart/form-data", // Ensures correct data encoding
    // }}
  )
  return response.data;
};

export const fetchJibebeMikopo = async () => {
  const response = await axios.get(`${API_BASE_URL}/jibebe/api/v1/jibebe-mkopo`,
    {
      headers: { Authorization: `Token ${localStorage.getItem("token")}` }
    }
  );
  return response.data;
};


// ─── Asset Categories (admin-managed) ────────────────────────────────────────
export const fetchAssetCategories = async (assetType) => {
  const url = assetType
    ? `${API_BASE_URL}/urithi/api/v1/asset-categories/?asset_type=${assetType}`
    : `${API_BASE_URL}/urithi/api/v1/asset-categories/`;
  const { data } = await axios.get(url);
  return data;
};
 
export const createAssetCategory = async (payload) => {
  const token = localStorage.getItem('token');
  const { data } = await axios.post(
    `${API_BASE_URL}/urithi/api/v1/asset-categories/`,
    payload,
    { headers: { Authorization: `Token ${token}` } }
  );
  return data;
};
 
export const updateAssetCategory = async ({ id, data }) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(
    `${API_BASE_URL}/urithi/api/v1/asset-categories/${id}/`,
    data,
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};
 
export const deleteAssetCategory = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(
    `${API_BASE_URL}/urithi/api/v1/asset-categories/${id}/`,
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};
 
// ─── Quantity Units (admin-managed) ──────────────────────────────────────────
export const fetchQuantityUnits = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/urithi/api/v1/quantity-units/`);
  return data;
};
 
export const createQuantityUnit = async (payload) => {
  const token = localStorage.getItem('token');
  const { data } = await axios.post(
    `${API_BASE_URL}/urithi/api/v1/quantity-units/`,
    payload,
    { headers: { Authorization: `Token ${token}` } }
  );
  return data;
};
 
export const updateQuantityUnit = async ({ id, data }) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(
    `${API_BASE_URL}/urithi/api/v1/quantity-units/${id}/`,
    data,
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};
 
export const deleteQuantityUnit = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(
    `${API_BASE_URL}/urithi/api/v1/quantity-units/${id}/`,
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

// ─── Miza Net (JCards) Admin ────────────────────────────────────────────────────
export const fetchMiNetStats = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE_URL}/api/v1/jcards/admin/stats/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

export const fetchAllCards = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE_URL}/api/v1/jcards/admin/cards/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

export const fetchAllChats = async (flaggedOnly = false) => {
  const token = localStorage.getItem('token');
  const url = flaggedOnly
    ? `${API_BASE_URL}/api/v1/jcards/admin/chats/?flagged=true`
    : `${API_BASE_URL}/api/v1/jcards/admin/chats/`;
  const response = await axios.get(url, { headers: { Authorization: `Token ${token}` } });
  return response.data;
};

export const flagChatMessage = async ({ messageId, action, flag_reason }) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_BASE_URL}/api/v1/jcards/admin/chats/${messageId}/flag/`,
    { action, flag_reason },
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

// ─── Miza Net (JCards) Packages Admin ───────────────────────────────────────────
export const fetchMizaNetPackages = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE_URL}/api/v1/jcards/admin/packages/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

export const createMizaNetPackage = async (packageData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_BASE_URL}/api/v1/jcards/admin/packages/create/`,
    packageData,
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

export const updateMizaNetPackage = async ({ packageId, ...packageData }) => {
  const token = localStorage.getItem('token');
  const response = await axios.patch(
    `${API_BASE_URL}/api/v1/jcards/admin/packages/${packageId}/update/`,
    packageData,
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

export const deleteMizaNetPackage = async (packageId) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(
    `${API_BASE_URL}/api/v1/jcards/admin/packages/${packageId}/delete/`,
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

// ─── Contributions Ledger (Kileleni & Mbeleko base/compulsory → JamboRicG Wallet) ──
export const fetchContributionsLedger = async (params = {}) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE_URL}/wallet/api/v1/admin/contributions-ledger/`, {
    headers: { Authorization: `Token ${token}` },
    params,
  });
  return response.data;
};

// ─── Wallet Requests (deposit/withdrawal review) ──────────────────────────────
export const fetchWalletRequests = async (params = {}) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE_URL}/wallet/api/v1/admin/requests/`, {
    headers: { Authorization: `Token ${token}` },
    params,
  });
  return response.data;
};

export const approveDeposit = async (id, { provider_fee, platform_fee } = {}) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_BASE_URL}/wallet/api/v1/admin/deposits/${id}/approve/`,
    { provider_fee, platform_fee },
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

export const rejectWalletRequest = async (id, reason) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_BASE_URL}/wallet/api/v1/admin/requests/${id}/reject/`,
    { reason },
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

export const completeWithdrawal = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_BASE_URL}/wallet/api/v1/admin/withdrawals/${id}/complete/`,
    {},
    { headers: { Authorization: `Token ${token}` } }
  );
  return response.data;
};

// ─── Financial Tracker Admin ──────────────────────────────────────────────────
export const fetchFinancialAdminStats = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE_URL}/api/financial-tracker/admin/stats/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

export const fetchAdminProjects = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE_URL}/api/financial-tracker/admin/projects/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

// ─── Website content: Team ────────────────────────────────────────────────────
export const fetchTeamMembers = async () => {
  const token = localStorage.getItem('token');
  const { data } = await axios.get(`${API_BASE_URL}/website/api/v1/team/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return data;
};

export const createTeamMember = async (memberData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE_URL}/website/api/v1/team/`, memberData, {
    headers: { "Content-Type": "multipart/form-data", Authorization: `Token ${token}` },
  });
  return response.data;
};

export const updateTeamMember = async ({ id, data }) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE_URL}/website/api/v1/team/${id}/`, data, {
    headers: { "Content-Type": "multipart/form-data", Authorization: `Token ${token}` },
  });
  return response.data;
};

export const deleteTeamMember = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE_URL}/website/api/v1/team/${id}/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

// ─── Website content: Uploads ─────────────────────────────────────────────────
export const fetchWebsiteUploads = async () => {
  const token = localStorage.getItem('token');
  const { data } = await axios.get(`${API_BASE_URL}/website/api/v1/uploads/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return data;
};

export const createWebsiteUpload = async (uploadData) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(`${API_BASE_URL}/website/api/v1/uploads/`, uploadData, {
    headers: { "Content-Type": "multipart/form-data", Authorization: `Token ${token}` },
  });
  return response.data;
};

export const deleteWebsiteUpload = async (id) => {
  const token = localStorage.getItem('token');
  const response = await axios.delete(`${API_BASE_URL}/website/api/v1/uploads/${id}/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

// ─── Website content: Page content blocks ─────────────────────────────────────
export const fetchSiteContentBlocks = async () => {
  const token = localStorage.getItem('token');
  const { data } = await axios.get(`${API_BASE_URL}/website/api/v1/content/blocks/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return data;
};

export const updateSiteContentBlock = async ({ key, value }) => {
  const token = localStorage.getItem('token');
  const { data } = await axios.put(
    `${API_BASE_URL}/website/api/v1/content/blocks/${key}/`,
    { value },
    { headers: { Authorization: `Token ${token}` } },
  );
  return data;
};

// ─── Website content: Settings ────────────────────────────────────────────────
export const fetchSiteSettings = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/website/api/v1/settings/`);
  return data;
};

export const updateSiteSettings = async (data) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(`${API_BASE_URL}/website/api/v1/settings/`, data, {
    headers: { Authorization: `Token ${token}` },
  });
  return response.data;
};

// ─── Messages (SMS / WhatsApp) ────────────────────────────────────────────────
const messagingHeaders = () => ({ Authorization: `Token ${localStorage.getItem('token')}` });

export const fetchSmsBalance = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/api/messaging/balance/`, { headers: messagingHeaders() });
  return data;
};

export const fetchSmsSegments = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/api/messaging/segments/`, { headers: messagingHeaders() });
  return data;
};

export const searchSmsRecipients = async (term) => {
  const { data } = await axios.get(`${API_BASE_URL}/api/messaging/recipients/`, {
    headers: messagingHeaders(),
    params: { q: term || '' },
  });
  return data;
};

export const previewSmsSend = async (payload) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/messaging/preview/`, payload, { headers: messagingHeaders() });
  return data;
};

export const sendSmsCampaign = async (payload) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/messaging/send/`, payload, { headers: messagingHeaders() });
  return data;
};

export const fetchSmsSettings = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/api/messaging/settings/`, { headers: messagingHeaders() });
  return data;
};

export const updateSmsSettings = async (payload) => {
  const { data } = await axios.put(`${API_BASE_URL}/api/messaging/settings/`, payload, { headers: messagingHeaders() });
  return data;
};

export const testSmsConnection = async () => {
  const { data } = await axios.post(`${API_BASE_URL}/api/messaging/test-connection/`, {}, { headers: messagingHeaders() });
  return data;
};

export const fetchSmsCampaigns = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/api/messaging/campaigns/`, { headers: messagingHeaders() });
  return data;
};

export const fetchSmsCampaign = async (id) => {
  const { data } = await axios.get(`${API_BASE_URL}/api/messaging/campaigns/${id}/`, { headers: messagingHeaders() });
  return data;
};

export const refreshSmsCampaign = async (id) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/messaging/campaigns/${id}/`, {}, { headers: messagingHeaders() });
  return data;
};

export const resendFailedSms = async (id) => {
  const { data } = await axios.post(`${API_BASE_URL}/api/messaging/campaigns/${id}/resend-failed/`, {}, { headers: messagingHeaders() });
  return data;
};

// ─── Audit Logs ────────────────────────────────────────────────────────────────
export const fetchAuditLogs = async (params = {}) => {
  const token = localStorage.getItem('token');
  const { data } = await axios.get(`${API_BASE_URL}/api/audit-log/api/v1/admin/logs/`, {
    headers: { Authorization: `Token ${token}` },
    params,
  });
  return data;
};

export const fetchPlatformAnalytics = async (params = {}) => {
  const token = localStorage.getItem('token');
  const { data } = await axios.get(`${API_BASE_URL}/api/audit-log/api/v1/admin/analytics/`, {
    headers: { Authorization: `Token ${token}` },
    params,
  });
  return data;
};

/** Downloads the audit trail as a CSV, using whatever filters are on screen. */
export const downloadAuditReport = async (params = {}) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_BASE_URL}/api/audit-log/api/v1/admin/logs/export/`, {
    headers: { Authorization: `Token ${token}` },
    params,
    responseType: 'blob',
  });

  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^"]+)"?/);
  const name = match ? match[1] : `audit-report-${new Date().toISOString().slice(0, 10)}.csv`;

  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return name;
};

export const fetchAuditLogFilterOptions = async () => {
  const token = localStorage.getItem('token');
  const { data } = await axios.get(`${API_BASE_URL}/api/audit-log/api/v1/admin/logs/filter-options/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return data;
};
